import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const SmallPrivate = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M10.4048 5H3.59524C2.43807 5 1.5 5.90106 1.5 7.01258V10.9874C1.5 12.0989 2.43807 13 3.59524 13H10.4048C11.5619 13 12.5 12.0989 12.5 10.9874V7.01258C12.5 5.90106 11.5619 5 10.4048 5Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M4.5 5.05V3.37C4.5 2.06 5.57234 1 6.9 1C8.22766 1 9.3 2.06 9.3 3.37V5.05",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeMiterlimit: "10"
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsxs("g", {
                    clipPath: "url(#clip0_4594_851)",
                    children: [
                        /*#__PURE__*/ jsx("path", {
                            d: "M10.4048 5H3.59524C2.43807 5 1.5 5.90106 1.5 7.01258V10.9874C1.5 12.0989 2.43807 13 3.59524 13H10.4048C11.5619 13 12.5 12.0989 12.5 10.9874V7.01258C12.5 5.90106 11.5619 5 10.4048 5Z",
                            stroke: "currentColor",
                            strokeWidth: "1.4"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M4.5 5.05V3.37C4.5 2.06 5.57234 1 6.9 1C8.22766 1 9.3 2.06 9.3 3.37V5.05",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeMiterlimit: "10"
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_4594_851",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

export { SmallPrivate as default };
